<template lang="html">
	<footer id="footer">

		<section class="newsletter-section-v1">
      <div class="container oversized-container">
        <div class="row flex-center-xy">
          <div class="col-md-6 col-lg-6 col-xl-7 col-title">
            <h2>Suscríbete al Newsletter</h2>
						<h5>Recibe información de promociones e información exlusiva</h5>
          </div>

          <div class="col-md-6 col-lg-6 col-xl-5 col-form">
            <b-form @submit="onSubmit">
              <b-form-group>
                <b-form-input
                  v-model="form.email"
                  type="email"
                  required
                  placeholder="Escribe tu correo"
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" class="btn-send">SUSCRIBIRSE</b-button>
            </b-form>
          </div>
        </div>
      </div>
    </section>

		<div class="footer-content">
			<div class="container oversized-container">
				<div class="row">
					<div class="col-sm-5 col-lg-4 col-footer">
						<h6 class="title">Ayuda</h6>

						<p class="mb-1">
							<router-link to="/tutoriales">Tutoriales</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/preguntas-frecuentes">Preguntas frecuentes</router-link>
						</p>

						<p class="mt-2">
							<a class="t-250 btn-bubble btn-purple" href="tel:*611">Llamar al *611</a>
						</p>
						<p class="mt-2">
							<router-link class="t-250 btn-bubble btn-pink" to="/contacto">Enviar correo</router-link>
						</p>
						<!-- <p class="mt-2">
							<a class="t-250 btn-bubble btn-orange" href="#">Chat</a>
						</p> -->
					</div>

					<div class="col-sm-7 col-lg-4 col-footer">
						<h6 class="title">Aviso Legal</h6>

						<p class="mb-1">
							<router-link to="/codigo-de-politicas-de-gestion-de-trafico-y-administracion-de-red">Código de políticas de gestión de tráfico y administración de red.</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/carta-de-derechos-de-los-usuarios-ift-y-profeco">Carta de Derechos de los Usuarios IFT y Profeco.</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/codigo-de-practicas-comerciales">Codigo de prácticas comerciales.</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/informacion-sobre-colaboracion-en-materia-de-seguridad-y-justicia">Información sobre colaboración en materia de seguridad y justicia.</router-link>
						</p>
						<p>
							<router-link to="/aviso-de-inicio-de-operaciones-elux">Aviso de Inicio de Operaciones ELUX.</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/contrato-marco-de-prestacion-de-servicios-de-telecomunicaciones">Contrato marco de prestación de servicios de telecomunicaciones.</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/oficio-de-aprobacion">Oficio de Aprobación del Contrato de Adhesión del Servicio de Telefonía Móvil en la modalidad de Prepago en favor de ELUX MOBILE DE MÉXICO, S.A. de C.V.</router-link>
						</p>
						<p class="mb-1">
							<router-link to="/terminos-y-condiciones">Términos y condiciones.</router-link>
						</p>
					</div>

					<div class="col-lg-4 col-footer col-images">
						<div class="box">
							<router-link class="btn-logo" to="/">
								<img src="public/images/logo-white.svg">
							</router-link>

							<p class="mt-3 mt-lg-5">
								<a class="t-250 btn-app" href="https://play.google.com/store/apps/details?id=com.sustam.skycel&hl=es">
									<img src="public/images/shared/google-play.svg">
								</a>
							</p>
							<p class="mt-3">
								<a class="t-250 btn-app" href="https://apps.apple.com/us/app/skycel/id1616697589">
									<img src="public/images/shared/app-store.svg">
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</footer>
</template>

<script>
export default {
	data(){
		return{
			form: {
        email: null,
      }
		}
	},

	methods: {
    onSubmit(evt) {
      evt.preventDefault();
      var r = confirm("¿Deseas regístrate en newsletter? ");
      if (r == true) {
        axios.post(tools.url("/newsletter"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Message sent');
          this.form = {
            email: null,
          };
        }).catch( (error)=> {
          // console.log(error.response);
          let errors = error.response.data;
          // console.log(errors);
          this.makeToast('danger', error.response.data.email, 'Error');
        });
      }
    }
  }
}
</script>
